import { DatePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import { PROFIL, TRJT_TYPE } from '../../../constants/enum';
import MyButton from '../../Layout/MyButton';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect, useState } from 'react';
import MySelect from '../../Layout/MySelect';
import moment from 'moment';

const StepDatePassage = (props) => {
  const {
    refs,
    profil,
    trajetDescr,
    handleChange,
    demandePassageStyle,
    handleChangeDate,
    datePassage,
    setDatePassage,
    demandePassage,
    validSteps,
    onNextStep,
    notAbleToChange,
    reference
  } = props;
  const [duration, setDuration] = useState(null);
  const editable = validSteps.step5 && (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.CLIENT) || notAbleToChange;

  const durationDatas = [
    {
      key: 12,
      value: '12 mois',
    },
  ];

  if (reference?.typeDemande !== 'superieur') {
    durationDatas.push({
      key: 6,
      value: '6 mois',
    });
  }

  useEffect(() => {
    if (datePassage !== null) {
      setDuration(Number(datePassage.duration));
    }
  }, [datePassage]);
  useEffect(() => {
    if (duration) {
      setDatePassage({
        ...datePassage,
        endDate: moment(datePassage.startDate).add(Number(duration), 'months').endOf('day').format(),
        duration: duration,
      });
    }

  }, [duration]);

  const handleDurationChange = (e) => {
    setDuration(Number(e.target.value));
  };

  return (<div ref={(divRef) => refs.current['step-date_passage'] = divRef} className='step'>
    <div className='step-content'>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <h3 className='modal-step-title'>Date de passage / Durée d'autorisation</h3>
        <div className='row'
             style={{ flexWrap: 'nowrap', justifyContent: 'left', height: 'auto', marginBottom: '20px' }}>
          <DatePicker
            label='DATE DÉBUT SOUHAITÉE'
            name='startDate'
            value={datePassage.startDate || null}
            style={demandePassageStyle.textField}
            onChange={(newValue) => handleChangeDate(datePassage, setDatePassage, 'startDate', newValue)}
            renderInput={(params) => <TextField {...params} />}
            inputVariant='outlined'
            disabled={editable || reference?.typeDemande === 'superieur'}
          />
          <MySelect
            labelClass={'select-label-black'}
            name={'duration'}
            label={'DURÉE'}
            disableClass={true}
            style={{ minWidth: '150px' }}
            displayLabel={true}
            datas={durationDatas}
            value={Number(duration) || null}
            handleChange={(e) => handleDurationChange(e)}
            disabled={editable}
          />
        </div>
        <div style={{
          display: 'flex',
          justifyContent: 'flex-start',
          flexDirection: 'column',
          marginLeft: '30px',
          marginBottom: '20px',
        }}>
          <div>TRAJET ALLER</div>
          <TextField
            label='Nombre de passages'
            type='text'
            name='nbPassageAller'
            value={datePassage.nbPassageAller || ''}
            style={{ maxWidth: '15%', margin: '20px' }}
            autoComplete='off'
            fullWidth={false}
            onChange={(e) => handleChange(e, datePassage, setDatePassage, '^[0-9]*$')}
            inputProps={{ maxLength: 255 }}
            disabled={editable}
          />
          <TextField
            label='Nombre de véhicules'
            type='text'
            name='nbVehiculeAller'
            value={datePassage.nbVehiculeAller || ''}
            style={{ maxWidth: '15%', margin: '20px' }}
            autoComplete='off'
            fullWidth={false}
            onChange={(e) => handleChange(e, datePassage, setDatePassage, '^[0-9]*$')}
            inputProps={{ maxLength: 255 }}
            disabled={editable}
          />
        </div>
        {trajetDescr.type === TRJT_TYPE.ALLER_RETOUR &&
          <div style={{
            display: 'flex',
            justifyContent: 'flex-start',
            flexDirection: 'column',
            marginLeft: '30px',
            marginBottom: '20px',
          }}>
            <div>TRAJET RETOUR</div>
            <TextField
              label='Nombre de passages'
              type='text'
              name='nbPassageRetour'
              value={datePassage.nbPassageRetour || ''}
              style={{ maxWidth: '15%', margin: '20px' }}
              autoComplete='off'
              fullWidth={false}
              onChange={(e) => handleChange(e, datePassage, setDatePassage, '^[0-9]*$')}
              inputProps={{ maxLength: 255 }}
              disabled={editable}
            />
            <TextField
              label='Nombre de véhicules'
              type='text'
              name='nbVehiculeRetour'
              value={datePassage.nbVehiculeRetour || ''}
              style={{ maxWidth: '15%', margin: '20px' }}
              autoComplete='off'
              fullWidth={false}
              onChange={(e) => handleChange(e, datePassage, setDatePassage, '^[0-9]*$')}
              inputProps={{ maxLength: 255 }}
              disabled={editable}
            />
          </div>}
      </div>

      {(profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE) && demandePassage.id !== 0 &&
        <div className='row' style={{ justifyContent: 'flex-end', alignItems: 'center', height: '80px' }}>
          <MyButton
            style={validSteps['step5'] ? 'buttonRejected' : 'buttonValidation'}
            label={validSteps['step5'] ? 'Rejeter l\'étape' : 'Valider l\'étape'}
            icon={validSteps['step5'] ? faXmark : faCheck}
            onClick={() => {
              onNextStep(setDatePassage, datePassage, 5);
            }}
          />
        </div>}
    </div>
  </div>);
};

export default StepDatePassage;